<template lang="html">
  <h3>Editar {{client}}</h3>
</template>

<script>
export default {
  data(){
    return{
      client:''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/clients/Edit_client.vue